import React, { Fragment } from "react";
import {
  Breadcrumb,
  Typography,
  Divider,
  Input,
  Drawer,
  Space,
  Button,
  message,
  Tag,
  Row,
  Col,
  Form,
  Select,
  InputRef,
  InputNumber,
  Upload,
} from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import seekSolutionApi from "../../utils/seekSolutionApi";
import { Link, useNavigate } from "react-router-dom";
import LanguageCode from "../../utils/ISO_639-2.json";
import {
  RcFile,
  UploadChangeParam,
  UploadFile,
  UploadProps,
} from "antd/es/upload";
import SeekSolutionS3Bucket from "../../utils/SeekSolutionS3Bucket";
import { getBase64 } from "../../utils/uiSettings";
import { ICategory } from "../../context/interfaces";
const { Title } = Typography;

const CollageCreate = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const categoryInputRef = React.useRef<InputRef>(null);
  const topicInputRef = React.useRef<InputRef>(null);
  const technologyInputRef = React.useRef<InputRef>(null);
  const [imageUrl, setImageUrl] = React.useState<string>();

  const [collage, setCollage] = React.useState<{count:number,data:Array<ICategory>,text:string}>({
    count: 0,
    data: [],
    text: "",
  });
  

 

  const onClose = () => {
    setOpen(false);
  };

  const initialise = async (values: any) => {
   
    try {
        setLoading(true);
        let apiRes = await seekSolutionApi.colleges.create({
          ...values,
          // banner: bucketKey,
        });
        console.log("apiRes", apiRes);
        localStorage.removeItem("courses_draft");
        form.resetFields();
        navigate(`/colleges/page/-1`, {
          replace: true,
        });
      } catch (error) {
      } finally {
        setLoading(false);
      }
      
  };

  const handleSubmit = async (values: any) => {
    console.log("handle submit running");
    setLoading(true);
    localStorage.setItem("courses_draft", JSON.stringify(values));
    await initialise(values);
    setLoading(false);
  };

  React.useEffect(() => {
  
  }, []);
  return (
    <Fragment>
      <Space direction="vertical" style={{ display: "flex" }}>
        <Breadcrumb
          items={[
            {
              title: "Management",
            },
            {
              title: <Link to={`/colleges/page/1`}>College</Link>,
            },
            {
              title: "Create",
            },
          ]}
        />
        <Title level={2}>College</Title>
        <Form
          onFinish={handleSubmit}
          form={form}
          initialValues={{
            ...JSON.parse(localStorage.getItem("courses_draft") as string),
          }}
          layout="vertical"
        >
        <Form.Item
        name={"name"}
        label="Name"
        required
        tooltip="This is a required field"
      >
        <Input placeholder="Enter your name" />
      </Form.Item>
      <Form.Item
        name={"code"}
        label="Code"
        required
        tooltip="code is required"
      >
         <Input placeholder="Enter your code" />
      </Form.Item>
      <Form.Item
        name={"address"}
        label="Address"
        required
        tooltip="This is a required field"
      >
        <Input placeholder="Enter your address" />
      </Form.Item>
      <Form.Item
        name={"city"}
        label="City"
        required
        tooltip="This is a required field"
      >
        <Input  placeholder="Enter your city" />
      </Form.Item>
      <Form.Item
        name={"state"}
        label="State"
        required
        tooltip="This is a required field"
      >
        <Input   placeholder="Enter your state" />
      </Form.Item>
      <Form.Item
        name={"pincode"}
        label="Pincode"
        required
        tooltip="This is a required field"
      >
        <Input placeholder="Enter your pincode" />
      </Form.Item>
      <Form.Item
        name={"lat"}
        label="Lat"
        required
        tooltip="This is a required field"
      >
        <Input placeholder="Enter your lat" />
      </Form.Item>
      <Form.Item
        name={"lng"}
        label="Lng"
        required
        tooltip="This is a required field"
      >
        <Input placeholder="Enter your lng" />
      </Form.Item>
      <Button type="primary" htmlType="submit" loading={loading}>
        Create
      </Button>
    </Form>
  </Space>
  <Drawer
    title="Filter"
    placement={"right"}
    width={500}
    onClose={onClose}
    open={open}
    extra={
      <Space>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="primary" onClick={onClose}>
          Apply
        </Button>
      </Space>
    }
  >
    <p>Some contents...</p>
  </Drawer>
</Fragment>

  );
};
export default CollageCreate;
